// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"VS_thecomp__bOON2"};